export enum LayoutPageTitleEnum {
  Primary = 'Primary',
  Secondary = 'Secondary',
}
